import React from "react"
import { OldButton } from "@kit/design/old-button"
import Modal from "@kit/design/modal"
import Stack from "@kit/design/stack"
import celebrationImage from "../../../../../assets/images/kit-celebration-blue.png"
import { usePlanComparisonContext } from "./context"

function defaultMessage(toPlan) {
  if (toPlan.service_level === "creator") {
    return "You have access to Kit's powerful automation features on this plan. Find these features under the 'Send' and 'Automate' menu items."
  } else {
    return "You now have access to Kit's powerful features to automate & scale your business."
  }
}

export const Celebration = ({ afterCelebration, message, hideHeader }) => {
  const { toPlan } = usePlanComparisonContext()

  message = message || defaultMessage(toPlan)

  return (
    <Modal
      onClose={afterCelebration}
      label=" "
      width="600px"
      data-testid="celebration-modal"
    >
      <Stack spacing={3} className="items-center mb-2 -mt-8">
        {!hideHeader && (
          <>
            <img alt="" src={celebrationImage} width={186} className="mb-4" />
            <p className="font-heading text-title text-gray-900">Congrats!</p>
          </>
        )}
        <h2 className="font-semibold text-lg text-center text-gray-900">
          You&apos;re now on the {toPlan.display_name} Plan!
        </h2>
        <p className="text-gray-900 text-base text-center my-2">{message}</p>
        <OldButton is="primary" onClick={afterCelebration} className="px-8">
          Jump in
        </OldButton>
      </Stack>
    </Modal>
  )
}
